<template>
    <div class="description">
        <p class="description-content" v-html="description" />
        <div class="description-button-container">
            <button class="description-button-container-button" @click="onAgree">
                已阅读并同意
            </button>
        </div>
    </div>
</template>

<script>
import { NavigationTool } from '@/utils/navigation-tool.js'
export default {
    data() {
        return {
            description: ''
        }
    },

    created: function () {
        this.description = this.$router.history.current.query.description
    },

    methods: {
        onAgree() {
            // 页面跳转
            NavigationTool.descriptionNavigate()
        }
    }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";

.description {
    background-color: #f9f9f9;
    width: 100%;
    height: 100%;

    &-content {
        background-color: #f9f9f9;
        color: #323233;
        font-size: 12px;
        font-weight: 500;
        line-height: 24px;
        white-space: pre-wrap;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        padding: 38px 17px 120px 16px;

        ::-webkit-scrollbar {
            width: 0 !important;
        }

        ::-webkit-scrollbar {
            width: 0 !important;
            height: 0;
        }
    }

    &-button-container {
        background-color: white;
        width: 100%;
        height: 100px;
        position: fixed;
        bottom: 0px;
        display: flex;
        align-items: center;
        justify-content: center;

        &-button {
            background-color: #596afd;
            color: white;
            font-size: 16px;
            width: 343px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 22px;
        }
    }
}
</style>
